import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {MediaQuery} from '@services/MediaQuery';

export class FixedButton extends ConnectedComponent {
  observer: IntersectionObserver | null = null;
  contactSection: HTMLDivElement | null = null;
  checkbox: HTMLInputElement[] = [];
  mq = MediaQuery.create();

  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onIntersection = this.onIntersection.bind(this);
  }

  didMount() {
    this.checkbox = [
      ...document.querySelectorAll('input[name="your-category"]'),
    ] as HTMLInputElement[];

    this.contactSection = document.querySelector('.o-contact');
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'endHideAnimation') {
        // this.element?.classList.add('viewed');
      }
    });

    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: '0px',
      threshold: [0.2],
    });

    this.contactSection && this.observer.observe(this.contactSection);

    this.on('click', this.onClick);
  }

  onClick() {
    this.checkbox.map((c) => {
      c.checked = true;
      c.dispatchEvent(new Event('change'));
    });
  }

  didUnmount() {
    this.contactSection && this.observer?.unobserve(this.contactSection);
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (entry.boundingClientRect.y > 0) {
        if (this.mq.isDesktop()) {
          if (entry.isIntersecting) {
            anime({
              duration: 300,
              easing: 'easeOutCubic',
              right: -100,
              targets: this.element,
            });
          } else {
            anime({
              duration: 300,
              easing: 'easeInOutCubic',
              right: '0',
              targets: this.element,
            });
          }
        } else {
          if (entry.isIntersecting) {
            anime({
              bottom: -100,
              duration: 300,
              easing: 'easeOutCubic',
              targets: this.element,
            });
          } else {
            anime({
              bottom: '0',
              duration: 300,
              easing: 'easeInOutCubic',
              targets: this.element,
            });
          }
        }
      }
    }
  }
}
